//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Preferences.js";
import "../no/Object.js";
import "../no/Routing.js";
import "../Preferences/Preferences.RoutingApplicationView.js";
let d=[[[0,"AutoRouteStockStyle",1,0],[0,"AutomaticRouteLevel",1,0],[0,"BundleColor",1,0],[0,"ComponentMatchMethod",1,0],[0,"CreateTerminalsOption",1,0],[0,"DefaultJumperLength",1,0],[0,"ExportFormatInLegacyFile",1,0],[0,"FormboardSynchronizationLengthTolerance",1,0],[0,"HighlightWire",1,0],[0,"RecordNetlistHistory",1,0],[0,"ReportRouteErrors",1,0],[0,"TerminalSegmentSolidDisplay",1,0]],[[[],"GetDefaultHarnessName",{R_:{default_harness_name:''}},0,0],[["default_harness_name"],"SetDefaultHarnessName",{},1,0],[[],"GetComponentMatchColumnHeading",{R_:{column_heading:''}},0,0],[["column_heading"],"SetComponentMatchColumnHeading",{},1,0],[[],"GetComponentMatchComponentAttributeTitle",{R_:{component_attribute_title:''}},0,0],[["component_attribute_title"],"SetComponentMatchComponentAttributeTitle",{},1,0],[[],"GetFilterBlankingAttribute",{R_:{attribute_name:''}},0,0],[["attribute_name"],"SetFilterBlankingAttribute",{},1,0],[["number_of_frames"],"GetFormboardFrameSizes",{R_:{frames:""}},0,0],[["frame_sizes"],"SetFormboardFrameSizes",{},1,0]],[]];
SPLM.Preferences.RoutingElectrical = class extends SPLM.Object{
    constructor (owner){
        if(owner !== undefined){
            if(owner._owner !== undefined){
                super(owner._owner);
                this._owner = owner._owner;
            }
            else{
                super(owner);
                this._owner = owner;
            }
            this._d['ObjectId'] = this._owner._d['ObjectId'];
        }
        else{
            super();
        }
        this._d['Class'] = "SPLM.Preferences.RoutingElectrical";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Preferences.RoutingElectrical.CreateTerminalsType = Object.freeze({
    "All" : "All", "Listed" : "Listed", "Routed" : "Routed"});

SPLM.Preferences.RoutingElectrical.ComponentMatchType = Object.freeze({
    "FileName" : "FileName", "ComponentName" : "ComponentName", "AttributeName" : "AttributeName"});

export default SPLM;